import { useState } from "react";
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogTrigger,
  DialogFooter,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";

interface CommentDialogProps {
  label: string;
  comment: string;
  onCommentChange: (comment: string) => void;
}

export function CommentDialog({ label, comment, onCommentChange }: CommentDialogProps) {
  const [open, setOpen] = useState(false);
  const [tempComment, setTempComment] = useState(comment);

  const handleSave = () => {
    onCommentChange(tempComment);
    setOpen(false);
  };

  const handleCancel = () => {
    setTempComment(comment); // Reset to original comment
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon">
          <MessageSquare className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Comments for {label}</DialogTitle>
        </DialogHeader>
        <Textarea
          value={tempComment}
          onChange={(e) => setTempComment(e.target.value)}
          placeholder="Add notes or comments about this cost component..."
          className="min-h-[100px]"
        />
        <DialogFooter className="flex justify-end gap-2">
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}